import { render } from "./Buscador.vue?vue&type=template&id=976538e6"
import script from "./Buscador.vue?vue&type=script&lang=js"
export * from "./Buscador.vue?vue&type=script&lang=js"

import "./Buscador.vue?vue&type=style&index=0&id=976538e6&lang=css"

import exportComponent from "C:\\Users\\Fam. Pariona\\Documents\\Programación\\capitaltrabajo\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__